/**
 * Middleware global para abrir modais baseado em parâmetros da URL
 * Funciona em qualquer rota quando os parâmetros ?abrirModal=true&receitaId=xxx ou ?abrirModal=true&despesaId=xxx estão presentes
 */
export default defineNuxtRouteMiddleware((to) => {
  // Só executa se tiver o parâmetro abrirModal=true
  if (to.query.abrirModal !== 'true') { return }

  // Usa os parâmetros to em vez de useRoute() para evitar warnings
  const modalInfo = {
    shouldOpenModal: to.query.abrirModal === 'true',
    modalType: to.query.despesaId ? 'despesa' : to.query.receitaId ? 'receita' : null,
    entityId: (to.query.despesaId || to.query.receitaId) as string,
  }

  if (!modalInfo?.shouldOpenModal || !modalInfo?.entityId) { return }

  // Agenda a abertura do modal após a navegação completar
  // O setTimeout é necessário para garantir que a página e os stores estejam carregados
  setTimeout(async () => {
    try {
      const prestacaoStore = usePrestacaoDeContaStore()
      useStore().loading = true

      if (modalInfo.modalType === 'despesa') {
        // Usa a função existente do store para abrir modal de despesa
        await prestacaoStore.abrirModalDetalhesDespesa(modalInfo.entityId)
      } else if (modalInfo.modalType === 'receita') {
        // Nova função que será criada no store para abrir modal de receita
        await prestacaoStore.abrirModalReceitaPorId(modalInfo.entityId)
      }

      // Remove os parâmetros da URL após processar
      const newQuery = { ...to.query }
      delete newQuery.abrirModal
      delete newQuery.despesaId
      delete newQuery.receitaId
      delete newQuery._t // Remove também o timestamp que adicionamos

      await navigateTo({
        path: to.path,
        query: newQuery,
      }, { replace: true })
    } catch (error) {
      console.error('Erro ao abrir modal via URL:', error)
      useStore().toasts.push({
        content: `Erro ao carregar detalhes da ${modalInfo.modalType}`,
        color: 'danger',
      })
    } finally {
      useStore().loading = false
    }
  }, 100) // Pequeno delay para garantir que os stores estejam prontos
})
